// extracted by mini-css-extract-plugin
export default {"wrapper":"infraStructure_wrapper__hFS3o"};